import { Component, EventEmitter, OnInit, Input, Output, forwardRef, ViewChild } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem, InputMask} from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidatorWithParameters, phoneNumberValidatorWithParameters }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';
import { emailValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';
import { ContactGridComponent } from '../Grids/ContactGrid.component';

@Component({
  selector: 'my-contactdetails',
  templateUrl: './ContactDetails.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => ContactDetailsComponent)}]
})
export class ContactDetailsComponent extends BaseControlGroupComponent {

    contactDetailsForm: FormGroup;

    contactInfo: ent.ContactInfo = new ent.ContactInfo();
    
    @ViewChild(ContactGridComponent) contactGridComponent: ContactGridComponent;
    
    @Output() public copyOverallAccountPhoneNumberCopied: EventEmitter<boolean> = new EventEmitter();
    @Output() public copyOverallAccountEmailCopied: EventEmitter<boolean> = new EventEmitter();


    @Input() public showMultiple: boolean;
    @Input() public showUpdateNeeded: boolean;
    @Input() public showContactPersonName: boolean;
    @Input() public showBypassLastNameRequired: boolean;
    @Input() public showContactPhoneNumber: boolean;
    @Input() public showCopyOverallAccountPhoneNumber: boolean;
    @Input() public showContactPhoneExtension: boolean;
    @Input() public showSecondaryContactName: boolean;
    @Input() public showSecondaryContactPhoneNumber: boolean;
    @Input() public showContactPartnerNumber: boolean;
    @Input() public showAlternateContactPhoneNumber: boolean;
    @Input() public showAlternateContactPhoneExtension: boolean;
    @Input() public showEmail: boolean;
    @Input() public showCopyOverallAccountEmail: boolean;
    @Input() public showContactFaxNumber: boolean;
    @Input() public showContactDepartment: boolean;
    @Input() public showContactFunction: boolean;
    @Input() public setContactFunctionValueToDefault: boolean;
    @Input() public showAppliesToCustomer: boolean;
    @Input() public showAppliesToPayer: boolean;
    @Input() public showAppliesToField: boolean;

    @Input() public requireUpdateNeeded: boolean;
    @Input() public requireContactPersonName: boolean;
    @Input() public requireContactPersonLastName: boolean;
    @Input() public requireContactPhoneNumber: boolean;
    @Input() public requireContactPhoneExtension: boolean;
    @Input() public requireSecondaryContactName: boolean;
    @Input() public requireSecondaryContactPhoneNumber: boolean;
    @Input() public requireContactPartnerNumber: boolean;
    @Input() public requireAlternateContactPhoneNumber: boolean;
    @Input() public requireAlternateContactPhoneExtension: boolean;
    @Input() public requireEmail: boolean;
    @Input() public requireContactFaxNumber: boolean;
    @Input() public requireContactDepartment: boolean;
    @Input() public requireContactFunction: boolean;


    contactValidations: ent.ContactValidation[] = [];
  
    setRequestInfo(request: ent.Request){
        this.contactInfo = request.ContactInfo;
        if (this.contactGridComponent){
            this.contactGridComponent.records = request.ContactInfos;

            for (let item of request.ContactInfos){
                let contactInfo : ent.ContactInfo =  new ent.ContactInfo(item);

                item.AppliesToDisplayValue = contactInfo.setAppliesToDisplayValue();

                this.contactGridComponent.contactChanged.emit(item);
            }
        }
    }
    
    setDates(){}
    
    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          //'contactPersonName' : '',
          'firstName' : '',
          'lastName' : '',
          "bypassLastNameRequired" : '',
          'contactPhoneNumber' : '',
          'copyOverallAccountPhoneNumber' : '',
          'contactPhoneExtension' : '',
          'secondaryContactName' : '',
          'secondaryContactPhoneNumber' : '',
          'contactPartnerNumber' : '',
          'alternateContactPhoneNumber' : '',
          'alternateContactPhoneExtension' : '',
          'email' : '',
          'copyOverallAccountEmail' : '',
          'contactFaxNumber' : '',
          'contactDepartment' : '',
          'contactFunction' : '',
          'appliesToCustomer' : '',
          'appliesToPayer' : '',

        };
        
        this.contactDetailsForm = fb.group(group);

    }


    ngOnInit(): void {

        
        this.domainDataService.getContactValidations({ IncludeInactive: false }).subscribe(x=>{
            this.contactValidations = x;
            
            var emailValidators = [emailValidatorWithParameters(this.contactValidations), emailValidator];
            
        
            if(this.requireEmail) {
                emailValidators.push(Validators.required);
            }
            
            this.contactDetailsForm.controls.email.setValidators(emailValidators);


            if(this.requireContactPhoneNumber) {
                this.contactDetailsForm.controls['contactPhoneNumber'].setValidators([Validators.required, phoneNumberValidatorWithParameters(this.contactValidations)]);
            } 
            else {
                this.contactDetailsForm.controls['contactPhoneNumber'].setValidators(phoneNumberValidatorWithParameters(this.contactValidations));
            }

            if(this.requireAlternateContactPhoneNumber) {
                this.contactDetailsForm.controls['alternateContactPhoneNumber'].setValidators([Validators.required, phoneNumberValidatorWithParameters(this.contactValidations)]);
            }
            else {
                this.contactDetailsForm.controls['alternateContactPhoneNumber'].setValidators(phoneNumberValidatorWithParameters(this.contactValidations));
            }

            if(this.requireContactFaxNumber) {
                this.contactDetailsForm.controls['contactFaxNumber'].setValidators([Validators.required, phoneNumberValidatorWithParameters(this.contactValidations)]);
            }
            else {
                this.contactDetailsForm.controls['contactFaxNumber'].setValidators(phoneNumberValidatorWithParameters(this.contactValidations));
            }


        });
        
        if(this.requireContactPersonName) {
            this.contactDetailsForm.controls['firstName'].setValidators(Validators.required);
        }

        if(this.requireContactPersonLastName) {
            this.contactDetailsForm.controls['lastName'].setValidators(Validators.required);
        }

        if(this.requireContactPhoneExtension) {
            this.contactDetailsForm.controls['contactPhoneExtension'].setValidators(Validators.required);
        }

        if(this.requireSecondaryContactName) {
            this.contactDetailsForm.controls['secondaryContactName'].setValidators(Validators.required);
        }

        if(this.requireSecondaryContactPhoneNumber) {
            this.contactDetailsForm.controls['secondaryContactPhoneNumber'].setValidators(Validators.required);
        }

        if(this.requireContactPartnerNumber) {
            this.contactDetailsForm.controls['contactPartnerNumber'].setValidators(Validators.required);
        }     

        if(this.requireAlternateContactPhoneExtension) {
            this.contactDetailsForm.controls['alternateContactPhoneExtension'].setValidators(Validators.required);
        }        

        if(this.requireContactDepartment) {
            this.contactDetailsForm.controls['contactDepartment'].setValidators(Validators.required);
        }

        if(this.requireContactFunction) {
            this.contactDetailsForm.controls['contactFunction'].setValidators(Validators.required);
        }
    }

    ngAfterViewInit(){
        if (this.contactGridComponent != undefined && this.contactGridComponent.recordEditComponent != undefined) {
            this.contactGridComponent.recordEditComponent.hostedBy = Constants._HOSTED_BY_CONTACT_DETAILS;
        }
        
    }

    bypassLastNameRequired(event: boolean){
        this.setLastNameRequiredValidators(event);
    }

    setLastNameRequiredValidators(enabled: boolean){
        if(enabled){    
            this.contactDetailsForm.controls['lastName'].clearValidators();
        }else{
            if(this.showBypassLastNameRequired) {
                this.contactDetailsForm.controls['lastName'].setValidators(Validators.required);
            }              
        }
        this.contactDetailsForm.controls['lastName'].updateValueAndValidity()
    }

    isFieldValid(fieldName: string){
        var val = true;
        var form = this.contactDetailsForm;
        if (form.controls[fieldName].errors){
            if (form.controls[fieldName].errors.invalid){
                val = false;
            }
        }
        return val;
    }

    getCustomError(fieldName: string) : string{
        
        if (!this.isFieldValid(fieldName)) {
            return "";
        }
        var form = this.contactDetailsForm;
        if (form.controls[fieldName].errors){
            if (form.controls[fieldName].errors.customError){
                return form.controls[fieldName].errors.customError;
            }
        }
        return "";
    }

    contactDepartmentChange(event: any){
        this.contactInfo.ContactDepartmentID = event;
    }

    contactFunctionChange(event: any){
        this.contactInfo.ContactFunctionID = event;
    }

}
